@if (showXRay && speakers.length > 0) {
  <div class="wrapper">
    <div class="scroll-container">
      <div class="tracker-container">
        <div class="tracker" [style.left]="trackerLocation"></div>
        @for (speakerSlot of speakers; track speakerSlot.speaker.speakerId) {
          <app-speaker-x-ray-item
            [speakerSlot]="speakerSlot"
            [meeting]="meeting"
            [canEdit]="canEdit"
            [isLabelingModeFocusedOnSpeaker]="isLabelingModeFocusedOnSpeaker(speakerSlot)"
            [isActive]="speakerSlot.speaker.speakerTag === activeSpeakerId"
            (splitSpeakers)="splitSpeakers(speakerSlot.speaker.speakerTag)"
            (selectTime)="selectTime.emit($event)"
            (updateSpeakerName)="updateSpeakerName(speakerSlot.speaker.speakerTag, $event)"
            (skipLabelingSpeaker)="skipLabelingSpeaker()"
          ></app-speaker-x-ray-item>
        }
      </div>
    </div>
  </div>
}
